import React from "react";
import "./CashFlow.scss";
import CashFlowImg from "../../../assets/Reports/Cash-Flow-Statement-2024.png";

const CashFlow = () => {
  return (
    <>
      <div className="cash_flow">
        <div className="container">
          <div className="heading_box">Cash Flow Statement</div>
          <div className="my-5 text-center cashFlowImg">
            <img src={CashFlowImg} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CashFlow;
